var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.iconComponent,{tag:"component",staticClass:"custom-svg-icon",style:({ scale: _vm.scale }),attrs:{"role":"img","data-icon":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }